/* eslint-disable import/prefer-default-export */
import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import communicate from 'src/api/communicate';

export const REQUEST = 'LOAD_USERS_REQUEST';
export const SUCCESS = 'LOAD_USERS_SUCCESS';
export const FAIL = 'LOAD_USERS_FAIL';
export const OPTIONS_SUCCESS = 'LOAD_USERS_OPTIONS_SUCCESS';

const loadUsersRequest = () => ({ type: REQUEST });

const loadUsersSuccess = (users) => ({ type: SUCCESS, users });

const loadUsersFail = (users) => ({ type: FAIL, users });

const loadUsersOptionsSuccess = (usersOptions) => ({ type: OPTIONS_SUCCESS, usersOptions });

export const INFO_REQUEST = 'LOAD_USER_INFO_REQUEST';
export const INFO_SUCCESS = 'LOAD_USER_INFO_SUCCESS';
export const INFO_FAIL = 'LOAD_USER_INFO_FAIL';

export const DATA_REQUEST = 'LOAD_USER_DATA_REQUEST';
export const DATA_SUCCESS = 'LOAD_USER_DATA_SUCCESS';
export const DATA_FAIL = 'LOAD_USER_DATA_FAIL';

export const SET_SUPER_RIGHTS = 'SET_SUPER_RIGHTS';

export const SET_LOGGING_OUT = 'SET_LOGGING_OUT';

export const loadUserInfoRequest = () => ({ type: INFO_REQUEST });
export const loadUserInfoSuccess = (userInfo) => ({ type: INFO_SUCCESS, userInfo });
export const loadUserInfoFail = () => ({ type: INFO_FAIL });

export const loadUserDataRequest = () => ({ type: DATA_REQUEST });
export const loadUserDataSuccess = (userData) => ({ type: DATA_SUCCESS, userData });
export const loadUserDataFail = () => ({ type: DATA_FAIL });

export const VERSIONS_REQUEST = 'LOAD_VERSIONS_REQUEST';
export const VERSIONS_FAIL = 'LOAD_VERSIONS_FAIL';
export const VERSIONS_SUCCESS = 'LOAD_VERSIONS_SUCCESS';

const loadVersionsRequest = () => ({ type: VERSIONS_REQUEST });
const loadVersionsFail = () => ({ type: VERSIONS_FAIL });
const loadVersionsSuccess = (versions) => ({ type: VERSIONS_SUCCESS, versions });

export const setSuperRights = (isSuper) => ({ type: SET_SUPER_RIGHTS, isSuper });

export const setLoggingOut = (loggingOut) => ({ type: SET_LOGGING_OUT, loggingOut });

export function reformatUsersForOptionsMenu(data) {
  return data.map(({
    UserId,
    LastName,
    FirstName,
    ExternalCode
  }) => ({
    value: UserId ? UserId.toString() : '',
    label: `${LastName} ${FirstName}`,
    externalCode: ExternalCode
  }));
}

export const loadUsers = () => (dispatch) => {
  dispatch(loadUsersRequest());
  return communicate({ url: 'Users' }).then((response) => {
    dispatch(loadUsersSuccess(response.data.Data));
    dispatch(loadUsersOptionsSuccess(reformatUsersForOptionsMenu(response.data.Data)));
  }).catch((err) => {
    dispatch(loadUsersFail(err));
    toastrError(err);
  });
};

export const loadUserInfo = () => (dispatch) => {
  dispatch(loadUserInfoRequest());
  return new Promise((resolve, reject) => {
    communicate({ url: 'LoggedInUser' }).then((response) => {
      dispatch(loadUserInfoSuccess(response.data.Data));
      resolve(response.data.Data);
    }).catch((err) => {
      dispatch(loadUserInfoFail(err));
      if (err.response.status === 300) {
        reject(err.response);
      } else {
        toastrError(err);
      }
    });
  });
};

export const loadUserData = (params) => (dispatch) => {
  dispatch(loadUserDataRequest());
  return communicate({ url: 'Users/GetUserInfo', getParams: Utils.objects.getQueryStringFromObject(params) })
    .then((response) => {
      const data = response.data.Data;
      dispatch(loadUserDataSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(loadUserDataFail(err));
      toastrError(err);
      return Promise.reject(err);
    });
};

export const loadVersions = () => (dispatch) => {
  dispatch(loadVersionsRequest());
  return communicate({
    url: 'Versions',
    method: 'get'
  })
    .then((response) => {
      dispatch(loadVersionsSuccess(response.data.Data));
    })
    .catch((err) => {
      dispatch(loadVersionsFail(err));
      toastrError(err);
    });
};

export const changeUserCompany = async (id) => {
  try {
    await communicate({ url: `LoggedInUser?companyId=${id}`, method: 'put' });
    const channel = new BroadcastChannel('ccOfficeSessionChannel');
    channel.postMessage(Array.isArray(id) ? id[0] : id);
    channel.close();
  } catch (err) {
    toastrError(err);
  }
};
